module.exports = "/images/productos@2x.png?0ff312e15143a4febb7e26e33fdf5287";